import { render, staticRenderFns } from "./testSysRole.vue?vue&type=template&id=bc68de56&scoped=true"
import script from "./testSysRole.vue?vue&type=script&lang=js"
export * from "./testSysRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc68de56",
  null
  
)

export default component.exports